import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { StringKey } from '../../lang/index';
import {
  CapTableManagementTypes,
  EnterpriseFeatures,
} from '../../pages/company-setup/company-setup-form/enterprise-modal/enterprise-modal.types';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';

export enum ReasonToChangeToEnterprise {
  NEED_STAKEHOLDERS = 'need-stakeholders',
  NEW_FEATURES = 'new-features',
  PRIORITY_SERVICE = 'priority-service',
}

export const reasonToChangeToEnterpriseTitle: Record<ReasonToChangeToEnterprise, StringKey> = {
  [ReasonToChangeToEnterprise.NEED_STAKEHOLDERS]: 'NEED_ADDITIONAL_STAKEHOLDERS',
  [ReasonToChangeToEnterprise.PRIORITY_SERVICE]: 'NEED_PRIORITY_SERVICE',
  [ReasonToChangeToEnterprise.NEW_FEATURES]: 'NEED_NEW_FEATURES',
};

export const reasonToChangeToEnterpriseTitleMap = Object.entries(reasonToChangeToEnterpriseTitle);

type RequestEnterpriseDto = {
  additionalNotes?: string;
  anotherSoftware?: string;
  capTableManagement: CapTableManagementTypes;
  companyId: string;
  email?: string;
  features?: Record<EnterpriseFeatures, boolean>;
  name: string;
  phonoNumber?: string;
};

type RequestChangeToEnterpriseDto = {
  additionalNotes?: string;
  additionalNotesAboutStakeholders?: string;
  companyId: string;
  reasonsToChange: Record<ReasonToChangeToEnterprise, boolean>;
};

export const useEnterpriseRequest = () => {
  const { mutate: enterpriseRequest, isPending } = useAppMutation([QueryKey.CHANGE_TO_ENTERPRISE], {
    mutationFn: (body: RequestChangeToEnterpriseDto | RequestEnterpriseDto) =>
      ApiService.post(
        {
          endpoint: BackendRoute.COMPANIES,
          routePath: [body.companyId, 'request-enterprise'],
        },
        { body },
      ),
  });
  return { enterpriseRequest, isPending };
};
